// extracted by mini-css-extract-plugin
export default {"projectWrapper":"ProjectV2ItemStatusChangedEvent-module__projectWrapper__P33fG7T"};